import requestPostResendActivationEmail from 'agentHub/api/requestPostResendActivationEmail'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import { useAppSelector } from 'hooks/reduxHooks'
import noop from 'lib/function/noop'
import React, { useCallback } from 'react'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  requestedEmail: string
  onModeChange?: (mode: App.UiAccountModalMode) => void
}

function AgentHubResendActivationEmail(props: Props) {
  const {
    requestedEmail,
    onModeChange = noop,
  } = props
  const modalContext = useModalElementContext()
  const agentStatus = useAppSelector(state => state.agentHub.agentStatus[requestedEmail])

  const onBack = useCallback(() => {
    onModeChange('login')
  }, [onModeChange])

  const handleResendEmail = useCallback(async() => {
    if (agentStatus?.data?.agentId) {
      await requestPostResendActivationEmail(agentStatus.data.agentId)
      modalContext.resolve()
      showSnackbar('Activation email sent.', 'success')
    }
  }, [agentStatus, modalContext])

  return <>
    <ModalHeader title="Finish setting up your account" onBackButtonClick={onBack} />
    <ModalBody>
      <ModalContent>
        <VerticalSpacer gap={20}>
          <BodyText variant="large">
            Your account setup is not yet complete. To continue with your account set-up, we have sent an activation
            email to <b>{requestedEmail}</b>.
            <br /><br />
            Please check your inbox and follow the instructions provided in the email to continue.
          </BodyText>
          {!!agentStatus?.data?.agentId &&
            <BodyText variant="large">
              Don't see the email?{' '}
              <TextLink size="large" weight="regular" onClick={handleResendEmail}>Resend activation email</TextLink>
            </BodyText>}
        </VerticalSpacer>
      </ModalContent>
    </ModalBody>
  </>
}
export default AgentHubResendActivationEmail
